<template>
    <page>
        <module>
			    <c-form ref="form1">
					<c-form title="关于我们【中文】" >
						<c-form-item type="input" label="标题" name="ABOUT_TITLE_ZH"></c-form-item>
						<c-form-item type="input" label="副标题" name="ABOUT_SUB_TITLE_ZH"></c-form-item>
						<c-form-item type="textarea" label="描述" name="ABOUT_SUB_CONTENT_ZH"></c-form-item>
					</c-form>
					<c-form title="关于我们【英文】" >
						<c-form-item type="input" label="标题" name="ABOUT_TITLE_EN"></c-form-item>
						<c-form-item type="input" label="副标题" name="ABOUT_SUB_TITLE_EN"></c-form-item>
						<c-form-item type="textarea" label="描述" name="ABOUT_SUB_CONTENT_EN"></c-form-item>
					</c-form>
					<c-form title="联系信息" >
						<c-form-item type="input" label="客服电话【中文】" name="CUSTOMER_SERVICE_PHONE_ZH" ></c-form-item>
						<c-form-item type="input" label="客服电话【英文】" name="CUSTOMER_SERVICE_PHONE_EN" ></c-form-item>
						<c-form-item type="input" label="地址【中文】" name="CUSTOMER_SERVICE_ADDRESS_ZH" ></c-form-item>
						<c-form-item type="input" label="地址【英文】" name="CUSTOMER_SERVICE_ADDRESS_EN" ></c-form-item>
                        <c-form-item type="input" label="地图地址【中文】" name="MAP_URL_ZH"   ></c-form-item>
                        <c-form-item type="input" label="地图地址【英文】" name="MAP_URL_EN"   ></c-form-item>
						<c-form-item type="input" label="邮箱" name="CUSTOMER_SERVICE_EMAIL" ></c-form-item>
						<c-form-item type="input" label="抖音地址" name="DOUYIN" ></c-form-item>
						<c-form-item type="input" label="小红书地址" name="LINKEDIN" ></c-form-item>
						<c-form-item type="input" label="INSTAGRAM" name="INSTAGRAM" ></c-form-item>
						<c-form-item type="image" label="微信二维码" name="WECHAT_RQ_CODE_IMG"></c-form-item>
					</c-form>
			    </c-form>
            
				<template slot="button">
					<c-button size="m" power="m_about" @click="save()">保存</c-button>
				</template>
        </module>
    </page>
</template>

<script>
	import {mapState} from 'vuex'
	
    export default {
        name: 'm_about',

        components: {
        },

        props: {
            id: String
        },

        data() {
            return {
                fromData:{
                },
                switchOptions: [{
                    name: '开启',
                    value: 'ON'
                }, {
                    name: '关闭',
                    value: 'OFF'
                }],
	            outstockOptions: [{
		            name: '不支持',
		            value: '0'
	            }, {
		            name: '支持',
		            value: '1'
	            }],
            }
        },
        computed: {
          ...mapState(['systemConfig'])
        },

        watch: {

        },

        mounted() {
            this.getDetail();
        },

        methods: {
            getDetail() {
                this.request({
                    url: '/platform_config/list',
                    data: {
                        config_group: ""
                    },
                    loading: true,
                    success: data => {
                        let json = {};
                        data.forEach(function (item,i){
                            json[item.config_item_code] = item.config_item_value;
                        });
                        this.$nextTick(() => {
                            if(this.$refs.form1)this.$refs.form1.set(json);
                        });
                    }
                });
            },


            save() {
                let data1 = this.$refs.form1?this.$refs.form1.get():{};
                let submitData = Object.assign({},data1);
                let platform_config_list = [];
                for (let key in submitData) {
					platform_config_list.push({
						config_item_code: key,
						config_item_value: submitData[key] ? submitData[key].toString() : ''
					});
                }
                this.request({
                    url: '/platform_config/edit',
                    data: {
                        platform_config_list: platform_config_list
                    },
                    loading: true,
                    success: data => {
                        this.$store.dispatch('getSystemConfig');
                        this.$message({
                            text: '保存成功',
                            icon: 'success'
                        });
                        //刷新页面
                        this.getDetail();
                    }
                });
            }
        }
    }
</script>

<style lang="stylus" scoped>


</style>